import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IconChevronDown } from '../../storefront/icons';

// Approval state only — never name the customer's pricing tier.
const STATUS_COPY = {
  active: 'Trade account approved',
  pending: 'Trade approval pending',
};

const AccountMenu = ({ profile, initials, firstName, isAdmin, tradeStatus, onSignOut }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const statusCopy = STATUS_COPY[tradeStatus.state];

  return (
    <div className="tp-account" ref={rootRef}>
      <button
        type="button"
        className={`tp-account__trigger${open ? ' is-open' : ''}`}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Account menu"
        onClick={() => setOpen((value) => !value)}
      >
        <span className="tp-avatar">{initials}</span>
        {firstName && <span className="tp-account__first">{firstName}</span>}
        <IconChevronDown size={14} className="tp-account__chevron" />
      </button>

      {open && (
        <div className="tp-account__menu" role="menu">
          <div className="tp-account__head">
            <span className="tp-avatar tp-avatar--lg">{initials}</span>
            <span className="tp-account__who">
              <span className="tp-account__name">{profile?.name || 'Your account'}</span>
              {profile?.email && <span className="tp-account__email">{profile.email}</span>}
            </span>
          </div>
          {statusCopy && (
            <p className={`tp-status tp-status--${tradeStatus.state}`}>{statusCopy}</p>
          )}
          <Link role="menuitem" to="/dashboard" className="tp-account__item">
            Orders &amp; account
          </Link>
          {isAdmin && (
            <Link role="menuitem" to="/admin" className="tp-account__item">
              Admin panel
            </Link>
          )}
          <button
            role="menuitem"
            type="button"
            className="tp-account__item tp-account__item--quiet"
            onClick={() => {
              setOpen(false);
              onSignOut();
            }}
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  );
};

export default AccountMenu;
